var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block relative w-5 h-5 align-middle lg:w-4 lg:h-4"},[_c('img',{attrs:{"src":require(("@/assets/icons/editor/" + _vm.name + ".svg")),"alt":_vm.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }